import React, { Fragment, useState, createRef } from 'react';
import { BrowserRouter, Switch, Route, Header, Footer, CookiePopup } from 'components';
import { About, ShortWrap, Privacy, Terms, Home, Features, Programs, Overview, Transition, FAQ, Logout } from 'components';
import { useLocation, useUpdateEffect } from 'helpers';
import css from './app.scss';

const groups = [
  /login|upgrade|sign-up|contact|restore|go-premium/
];

export function App() {
  const location = useLocation();

  const [ module ] = /[^/]+/.exec(location.pathname) || [];

  const [ state, setState ] = useState({
    location,
    status: 'enter',
    refHeaderBreakpoint: createRef(),
    setReady: () => setState(state => {
      if (state.status == 'enter') {
        window.pageYOffset; //force reflow
        state = {
          ...state,
          status: 'enterActive',
          timer: setTimeout(() => setState(reset), 1000),
        }
      }
      return state;
    })
  });

  const startTransition = () => {
    window.scrollTo(0, 0);
    setState({
      ...state,
      location,
      cover: false,
      status: 'enter',
    });
  }

  useUpdateEffect(() => {
    clearTimeout(state.timer);
    for (var i = groups.length - 1; i >= 0; i--) {
      if (groups[i].test(location.pathname) && groups[i].test(state.location.pathname)) {
        //if prev and current in the same group - don't animate
        return setState({ ...state, location });
      }
    }
    setState({ ...state, cover: true });
  }, [ location.pathname ]);

  return (
    <Fragment>
      <Switch location={state.location}>
        <Route path="/:module(login|upgrade|sign-up|contact|restore|go-premium)/:option?"><ShortWrap {...state} /></Route>
        <Route path="/about"><About {...state} /></Route>
        <Route path="/logout"><Logout {...state} /></Route>
        <Route path="/features"><Features {...state} /></Route>
        <Route path="/overview"><Overview {...state} /></Route>
        <Route path="/privacy"><Privacy {...state} /></Route>
        <Route path="/programs"><Programs {...state} /></Route>
        <Route path="/terms"><Terms {...state} /></Route>
        <Route path="/faq"><FAQ {...state} /></Route>
        <Route><Home {...state} /></Route>
      </Switch>
      <Header {...state} />
      <Footer />
      <CookiePopup />
      <Transition in={state.cover} mountOnEnter unmountOnExit classNames={css.locals} onEntered={startTransition}>
        <div className={css('cover', module)} />
      </Transition>
    </Fragment>
  );
}

export function AppWrap() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

function reset(state) {
  return {
    ...state,
    status: undefined,
  }
}
